import { COMPANY } from "./legal";

/**
 * Where a business owner who is stuck can get help, outside the dashboard's own
 * Support tab. Used by the setup wizard's top bar, which is the place people
 * most often get stuck.
 */

/** The product walkthrough on YouTube. */
export const DEMO_VIDEO_URL = "https://www.youtube.com/watch?v=K4IAP9-5D9o";

/**
 * One short video per setup-wizard page, keyed by the step's slug in
 * `wizardSteps.js`. The wizard's demo link opens the one for the page being
 * filled in; a step missing here falls back to `DEMO_VIDEO_URL`.
 */
export const SETUP_STEP_VIDEOS = {
  welcome: "https://www.youtube.com/watch?v=4geUbDR7LzY",
  business: "https://www.youtube.com/watch?v=PUJKaHIpEuw",
  team: "https://www.youtube.com/watch?v=Wva9Av4Zfd8",
  services: "https://www.youtube.com/watch?v=8ZjdnAQnZ_c",
  page: "https://www.youtube.com/watch?v=VKenlHXCUxY",
};

/**
 * The videos for Site & widget: one per tab, and one of its own for the About
 * section, whose block editor is the site's body and the part people need
 * shown.
 */
export const SITE_VIDEOS = {
  site: "https://www.youtube.com/watch?v=OXSmPLX96jA",
  about: "https://www.youtube.com/watch?v=9DU5P4gh8Ec",
  widget: "https://www.youtube.com/watch?v=NyeT5vGxeBQ",
};

/**
 * A WhatsApp chat with us, opened on `COMPANY.phone` so the number lives in
 * one place. `message` pre-fills the chat box; it is the visitor's to edit or
 * delete before anything is sent, and it should never carry personal data —
 * it rides in the URL.
 */
export const whatsappChatUrl = (message) =>
  `https://wa.me/${COMPANY.phone.replace(/\D/g, "")}${
    message ? `?text=${encodeURIComponent(message)}` : ""
  }`;
